<template>
	<div>
		<van-nav-bar :title="$t('fkyq')" left-arrow @click-left="onClickLeft" />
		<div class="domes">
			<h4 style="margin-top:60px">
				{{$t('qdjfx')}}
			</h4>
			<div class="timedome">
				<div>{{$t('yxqks')}} <span class="tieml" @click="handeDate">{{dates}}</span> {{$t('nn')}}</div>
				<!-- <div @click="handeDate">
                    <input  id="tiems" disabled="disabled" type="text" v-model="date" >
                </div> -->

				<!-- <van-calendar v-model="show"  @confirm="onConfirm" color="#1989fa" /> -->
				<van-popup v-model="show" position="bottom" :style="{ height: '40%' }">
					<van-datetime-picker :confirm-button-text="$t('qd')" :cancel-button-text="$t('qx')"
						@confirm="onConfirm" v-model="currentTime" type="time" :title="$t('xzsj')"
						:columns-order="['hours', 'minutes']" :formatter="formatter" :min-hour="0" :max-hour="23" />
				</van-popup>

			</div>
			<p style="">{{$t('lj')}}：{{this.url}}</p>


		</div>
		<van-button style="margin-top:20px;" type="primary" v-clipboard:copy="url2" v-clipboard:success="onCopy"
			v-clipboard:error="onError" @click="ppp">{{$t('fx')}}</van-button>

		<!-- <van-button style="margin-top:20px;" type="primary"  @click="sss">ss</van-button> -->
		<!-- <div style="margin-top:80px">
            <van-button type="primary" v-clipboard:copy="url"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError" @click="handeShare">分享二维码链接</van-button> -->

		<!-- </div> -->
	</div>
</template>
<script>
	import {
		formatDate
	} from "@/utils";
	import {
		Toast
	} from 'vant';
	var languageType = navigator.systemLanguage || navigator.language;
	export default {
		data() {
			return {
				show: false,
				dates: '0:30',
				date: null,
				Userinf: JSON.parse(window.localStorage.getItem('datauser')),
				url: '',
				url2: '',
				times3: null,
				currentTime: '0:30',
				ztiems: '',
				// nowtimsf:''
				index: null
			}
		},
		mounted() {
			// let dates= parseInt(new Date().getTime()/1000)+1800
			// this.currentTime = formatDate(new Date(dates*1000),'hh:mm')
			// this.handeShare()
		},
		methods: {


			onClickLeft() {
				this.$router.go(-1);
			},
			handeDate() {
				this.show = true
			},

			formatter(type, val) {
				if (type === 'hour') {
					return val + this.$t('sss');
				}
				if (type === 'minute') {
					return val + this.$t('fff');
				}

				return val;
			},

			onConfirm(date) {
				let tiearr = date.split(':')
				let hours = tiearr[0] * 3600
				let mins = tiearr[1] * 60
				let times2 = new Date()
				let times = formatDate(times2, 'yyyy-MM-dd hh:mm:ss')
				let standard = new Date(times)
				this.date = standard.getTime() / 1000 + hours + mins
				this.ztiems = formatDate(new Date(this.date * 1000), 'yyyy-MM-dd hh:mm:ss')
				console.log(this.ztiems)
				this.dates = date

				console.log(`09`, this.dates)
				console.log(`0999`, this.date)

				this.show = false;
				this.handeShare()
			},
			async handeShare() {
				this.index = this.Userinf.mobile.indexOf('-') + 1
				let data = {
					method: 'co.wx.visit.link.get',
					user_id: this.Userinf.user_id,
					key_time: this.date,
					platform: 'pwa'
				}
				await this.$serve(data).then(res => {
					if (res.data.code == 0) {
						let url = document.location.href;
						let ss = url.indexOf('#/')
						url = url.substring(0, ss + 2)
						this.url = url + `sharepwa?code=${res.data.data}`
						this.url2 =
							`手机号 ${this.Userinf.mobile.substring(this.index)} 的朋友邀请您---请点击下面链接生成开门二维码---二维码有效期从现在开始至 ${this.ztiems} 内：---开门二维码链接：${this.url}`
						// if(this.url){
						//     this.onCopy()
						// }   
					} else {
						Toast.fail(this.$t('cdcc'))
					}
				})
			},
			onCopy() {
				Toast.success(this.$t('fzcgts'))
			},
			onError() {
				Toast.fail(this.$t('fzsb'))
			},

			sss() {



			},
			ppp() {
				if (this.date) {
					if (languageType != 'zh-CN') {
						if (navigator.canShare) {
							navigator.share({
									text:`A friend with mobile number ${this.Userinf.mobile.substring(this.index)} invite you --- please click the below link to generate the Door opening QR code. The QR code is valid from now to ${this.ztiems},  
Door opening QR code link:`,
									
									url: this.url,
								})
								.then(function() {
									console.log('Share was successful.')
								})
								.catch(function(error) {
									console.log('Sharing failed', error)
								});
						} else {
							this.onCopy()
						}
					} else {
						if (navigator.canShare) {
							navigator.share({
									text: `手机号 ${this.Userinf.mobile.substring(this.index)} 的朋友邀请您---请点击下面链接生成开门二维码---二维码有效期从现在开始至 ${this.ztiems} 内：---开门二维码链接：`,
									url: this.url,
								})
								.then(function() {
									console.log('Share was successful.')
								})
								.catch(function(error) {
									console.log('Sharing failed', error)
								});
						} else {
							this.onCopy()
						}
					}
				} else {
					Toast.fail(this.$t('qxzyxsj'))
				}

			}
		}
	}
</script>
<style scoped>
	.domes {
		/* width: 100%; */
		height: 100%;
		padding: 0px 20px 0px 34px;
		text-align: left;
	}

	.timedome #tiems {
		line-height: 35px;
		/* margin-top: 20px; */
		border: none;
		border-radius: 5px;
		border: 1px solid #cccccc;
		padding: 0px 0px 0px 10px;

	}

	.tieml {
		width: 70px;
		line-height: 30px;
		border: 1px solid #ccc;
		display: inline-block;
		text-align: center;
		color: red;
	}
</style>
